interface LineProps {
  cells:number[]
}

function Line(props:LineProps) {
  return (
    <div className="line">
      {props.cells?.map((x, i)=><div className={`cell cell-${x}`} key={i}>{x===0?' ':x}</div>)}
    </div>
  );
}

export default Line;
